import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=04c35a2e"
import script from "./BatchList.vue?vue&type=script&lang=js"
export * from "./BatchList.vue?vue&type=script&lang=js"
import style0 from "./BatchList.vue?vue&type=style&index=0&id=04c35a2e&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1398830977/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c35a2e')) {
      api.createRecord('04c35a2e', component.options)
    } else {
      api.reload('04c35a2e', component.options)
    }
    module.hot.accept("./BatchList.vue?vue&type=template&id=04c35a2e", function () {
      api.rerender('04c35a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BatchList.vue"
export default component.exports